<ng-template #noPermission><boma-unauthed></boma-unauthed></ng-template>
<ng-container
  *permissionChecker="
    { permissions: ['view-product-stock-rules'], requirement: 'all' };
    else noPermission
  "
>
  <boma-crud-table
    *ngIf="stockRules"
    [paginationData]="stockRules"
    [data]="stockRules.items"
    [displaySearchBar]="true"
    [headersValue]="'Stock Alert'"
    [requiredPermissions]="['add-stock-alert']"
    [selectableColumns]="columns"
    [allowDelete]="true"
    [createFormTemplateReferenceStyle]="{ width:'50%', height: '60%'}"
    (itemDeleted)="onDeleted($event)"
    (createSubmit)="createStockRule()"
    [createFormTemplateReference]="createFormTemplate"
    [createFormValid]="createFormGroup.valid"
  ></boma-crud-table>

  <ng-template #createFormTemplate>
    <ng-container
      *permissionChecker="
        { permissions: ['add-product-stock-rules'], requirement: 'all' };
        else noPermission
      "
    >
      <form [formGroup]="createFormGroup">
        <input
          hidden
          id="productId"
          formControlName="productId"
          pInputText
          type="text"
        />

        <div class="formgrid grid">
          <div class="field col-12">
            <boma-product-selector
              (selectedProductsChange)="handleProductsSelection($event)"
              [requireSelection]="true"
              [enableFilter]="true"
              [multipleProducts]="false"
              [selectedProduct]="selectedProduct"
              [placeHolderText]="'Select a Product'"
              [organisation]="organizationId"
            ></boma-product-selector>
          </div>

          <ng-container *ngIf="showLocationsBar">
            <div class="field col-12">
              <boma-location-search
                (locationSelectedChange)="locationHandler($event)"
                [multipleLocations]="false"
                placeHolderText="Select Location"
                [showLabel]="false"
                [placeHolderText]="'All Locations'"
              ></boma-location-search>
            </div>
          </ng-container>

          <!-- <div class="p-field">
          <label for="ruleType">Rule Type</label>
          <p-dropdown id="ruleType" formControlName="ruleType" [options]="ruleTypes"></p-dropdown>
        </div> -->

          <div class="field col-12">
            <label for="value">Alert when stock is equal or below:</label>

            <div class="button-group">
              <button
                *ngFor="let value of [10, 100, 250, 500, 1000]"
                type="button"
                class="p-button mr-1"
                [ngClass]="{
                  'p-button-primary': selectedValue === value,
                  'p-button-secondary': selectedValue !== value
                }"
                (click)="setValue(value)"
              >
                {{ value | number }}
              </button>
              <button
                type="button"
                class="p-button mr-1"
                [ngClass]="{
                  'p-button-primary': isCustomValue,
                  'p-button-secondary': !isCustomValue
                }"
                (click)="setCustomValue()"
              >
                Custom
              </button>
            </div>

            <input
              id="value"
              min="0"
              formControlName="value"
              pInputText
              type="number"
              class="mt-2 text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              *ngIf="isCustomValue"
            />
          </div>

          <div class="field-checkbox mt-2" *ngIf="!showLocationsBar">
            <p-checkbox
              id="applyToAllLocations"
              formControlName="applyToAllLocations"
              binary="true"
            ></p-checkbox>
            <label for="applyToAllLocations">All Locations</label>
          </div>
        </div>
      </form>
    </ng-container>
  </ng-template>
</ng-container>
